import extractShopifyId from './extract-shopify-id'

/**
 *
 * @param {Object} args
 * @param {*} args.sanityProduct
 * @param {*} args.shopifyProductSingle
 * @param {*} args.shopifyProductSubscription
 */
export default function getPurchaseOptions({
  sanityProduct,
  shopifyProductSingle,
  shopifyProductSubscription
} = {}) {
  if (!sanityProduct || !shopifyProductSingle) {
    return []
  }

  const singleProductVariants = shopifyProductSingle.variants.edges
    .map(o => o.node)
    .filter(o => !sanityProduct.subscriptionSkus?.includes(o.sku))

  const single = {
    id: extractShopifyId(shopifyProductSingle.id),
    type: 'single',
    title: 'single purchase',
    subtitle: '',
    containsCBD: sanityProduct.cbd,
    details: sanityProduct.purchaseSettings?.options?.single?.details,
    badge: sanityProduct.purchaseSettings?.options?.single?.badge,
    category: sanityProduct.category,
    product: shopifyProductSingle,
    options: shopifyProductSingle.options.filter(
      o => !isDefaultProductOption(o)
    ),
    variants: singleProductVariants,
    defaultVariant:
      (sanityProduct.shopify.defaultSku?.sku &&
        singleProductVariants.find(
          o => o.sku === sanityProduct.shopify.defaultSku.sku
        )) ||
      singleProductVariants[0]
  }

  if (
    single.options.length < 1 &&
    single.defaultVariant.title === 'Default Title'
  ) {
    single.defaultVariant.title = sanityProduct.title
  }

  if (!shopifyProductSubscription) {
    single.subtitle = ' '

    if (single.product.title.match(/gift card/i)) {
      single.title = single.options[0].name
    }

    return [single]
  }

  single.variants = [single.defaultVariant]
  single.options = []

  const subscriptionProductVariants = shopifyProductSubscription.variants.edges.map(
    o => o.node
  )
  let defaultSubscriptionVariant =
    subscriptionProductVariants.find(
      o => o.sku === single.defaultVariant?.sku
    ) || subscriptionProductVariants[0]

  if (
    defaultSubscriptionVariant &&
    !defaultSubscriptionVariant.compareAtPrice?.amount
  ) {
    const singleVariant = singleProductVariants.find(
      o => o.sku === defaultSubscriptionVariant.sku
    )
    defaultSubscriptionVariant = {
      ...defaultSubscriptionVariant,
      compareAtPrice: singleVariant?.price
    }
  }

  if (
    defaultSubscriptionVariant &&
    defaultSubscriptionVariant.title === 'Default Title'
  ) {
    defaultSubscriptionVariant = {
      ...defaultSubscriptionVariant,
      title: sanityProduct.title
    }
  }

  const subscription = {
    id: extractShopifyId(shopifyProductSubscription.id),
    type: 'subscription',
    title: 'subscribe & save',
    containsCBD: sanityProduct.cbd,
    details: sanityProduct.purchaseSettings?.options?.subscription?.details,
    badge: sanityProduct.purchaseSettings?.options?.subscription?.badge,
    category: sanityProduct.category,
    product: shopifyProductSubscription,
    options: [],
    variants: [defaultSubscriptionVariant],
    defaultVariant: defaultSubscriptionVariant,
    sellingPlans: shopifyProductSubscription.sellingPlans.map(o => ({
      ...o,
      key: o.name,
      value: o.id
    }))
  }

  return subscription ? [subscription, single] : [single]
}

function isDefaultProductOption(option) {
  return (
    option?.name === 'Title' &&
    option?.values.length === 1 &&
    option?.values[0] === 'Default Title'
  )
}
